import '../scss/main.scss';
import App from '@bbc/front-end-kit/js/components/App';
import _defaultsDeep from 'lodash/defaultsDeep';
import VideoFadeOut from './components/VideoFadeOut.js';
import HeroTextAnimation from './components/HeroTextAnimation.js';
import VideoViewportPlay from './components/VideoViewportPlay.js';
import Configuration from './components/Configuration.js';

// import { initTracking } from './tracking.js'

// import Swiper from 'swiper';
// import { Controller, Autoplay, Pagination, Navigation } from 'swiper/modules';
// Swiper.use([Controller, Autoplay, Pagination, Navigation]);

export default class MainApp extends App {

    // constructor
    constructor(args = {}) {
        // call super
        super(_defaultsDeep(args, {
            mediaQueries: [
                { name: 'maxWidthMedium', query: '(max-width: 1199px)' },
                { name: 'minWidthMedium', query: '(min-width: 1199px)' },
            ]
        }));
    }

    // methods
    initReady (args = {}) {
        // call super
        super.initReady();

        // Initialize hero text animation
        this.heroTextAnimation = new HeroTextAnimation();
        this.heroTextAnimation.init();

        // Initialize video fade out with callback to trigger text animation
        this.videoFadeOut = new VideoFadeOut({
            wrapperSelector: '[data-video-wrapper]',
            fadeOutClass: 'fade-out',
            onFadeOut: () => {
                this.heroTextAnimation.animate();
            }
        });

        // Initialize video viewport play
        this.videoViewportPlay = new VideoViewportPlay();

        // Initialize configuration component
        this.configuration = new Configuration();
    }

    
    // ===================================== //
    // === INIT AND DESTROY MOBILE MODES === //
    // ===================================== //

    initMaxWidthMedium(args = {}) {
        console.log('init small')

        // set mobile modes
        this.instances.run([

        ], { mobile: true });

        // init instances
    }

    destroyMaxWidthMedium(args = {}) {
        console.log('destroy small')

        // destructions
        this.instances.destroy([

        ])
    }

    initMinWidthMedium(args = {}) {
        console.log('init small')

        // set mobile modes
        this.instances.run([

        ], { mobile: false });

        // init instances
    }

    destroyMinWidthMedium(args = {}) {
        console.log('destroy small')

        // destructions
        this.instances.destroy([

        ])
    }
}

